import { render, staticRenderFns } from "./ServiceAssessmentObjectiveData.vue?vue&type=template&id=5445cbc1&scoped=true"
import script from "./ServiceAssessmentObjectiveData.vue?vue&type=script&lang=js"
export * from "./ServiceAssessmentObjectiveData.vue?vue&type=script&lang=js"
import style0 from "./ServiceAssessmentObjectiveData.vue?vue&type=style&index=0&id=5445cbc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5445cbc1",
  null
  
)

export default component.exports